import React from 'react';
import { AnalysisPageWrapper, StyledNav, StyledLinkContainer, AnalysisPageTitle, StyledNavItem, TopButton, SubmitButton, TopBar, AnalysisSubTitle, AnalysisTopButtons, Logo } from './AnalysisPage.styled';
import { Outlet, useLocation } from 'react-router-dom';
import { ReactComponent as LeftArrow } from '../../assets/arrow-left-circle.svg';
import { ReactComponent as DownloadIcon } from '../../assets/download-icon.svg';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useSelector, useDispatch } from 'react-redux';
import { DotPulse } from 'ldrs/react'
import 'ldrs/react/DotPulse.css'
import { assignLoadingPDF } from '../../features/analysisPageNav/analysisPageNav';
import { theme } from "../../styles/styles";

function AnalysisPage () {
   const location = useLocation();
   const navigate = useNavigate();
   const enableRecalculate = useSelector((state) => state.inputs.enableRecalculate);
   const loading = useSelector((state) => state.analysisPageNav.loadingPDF);
   const dispatch = useDispatch();

   return (
      <>
      <Header page='analysis'/>
      <AnalysisPageWrapper>
         <TopBar>
            <TopButton
               onClick={() => navigate('/input')}
            >
               <LeftArrow />
               Adjust Inputs
            </TopButton>
            {!loading ?
            (<TopButton
               onClick={() => {
                  dispatch(assignLoadingPDF(true));
                  navigate('/analysis/roi')}
               }
               width={enableRecalculate ? "250px" : ""}
               disabled={enableRecalculate}
            >
               <DownloadIcon />
               {!enableRecalculate ? "Export Results" : "Recalculate to Export Results"}
            </TopButton>) : 
               (<DotPulse
               size="43"
               speed="1.3"
               color={theme.voltBlue}
               />)}
         </TopBar>
         <TopBar>
         <AnalysisPageTitle>Analysis</AnalysisPageTitle>
         </TopBar>
         <AnalysisSubTitle>Click "Recalculate" to reflect changes across all pages and to enable PDF download.</AnalysisSubTitle>
         <StyledNav 
            variant="underline"
            defaultActiveKey={"ROI"}
            >
               <StyledLinkContainer to="costs" isActive = {location.pathname === "/analysis/costs"}>
                  <StyledNavItem eventKey={"Costs"}>Costs</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="incentives" isActive = {location.pathname === "/analysis/incentives"}>
                  <StyledNavItem eventKey={"Incentives"}>Incentives</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="roi" isActive = {location.pathname === "/analysis/roi"}>
                  <StyledNavItem eventKey={"ROI"} active>ROI</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="faqs" isActive = {location.pathname === "/analysis/faqs"}>
                  <StyledNavItem eventKey={"FAQs"}>More Info</StyledNavItem>
               </StyledLinkContainer>
         </StyledNav>
         <Outlet />
         <Footer />
      </AnalysisPageWrapper>
      </>
   )
};

AnalysisPage.propTypes = {};

export default AnalysisPage;
